import { createI18n } from 'vue-i18n'
import { useLanguageStore } from '@/stores/language'
import type { SupportedLanguage } from '@/stores/language'

// Import modular translation files
import en from '@/locales/en/index'
import sw from '@/locales/sw/index'
import fr from '@/locales/fr/index'

const messages = {
  en,
  sw,
  fr
}

// Create i18n instance
export const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: 'en', // Default locale
  fallbackLocale: 'en',
  messages,
  globalInjection: true // Enable global $t
})

// Function to change locale
export const setI18nLanguage = (locale: SupportedLanguage) => {
  i18n.global.locale.value = locale
}

// Initialize language from store
export const initializeI18n = () => {
  const languageStore = useLanguageStore()
  languageStore.initializeLanguage()
  setI18nLanguage(languageStore.currentLanguage)
  
  // Watch for language changes
  languageStore.$subscribe((mutation, state) => {
    setI18nLanguage(state.currentLanguage)
  })
}